<template>
  <v-card outlined class="pa-4 ma-0 d-flex flex-column gap-3" style="height: 350px">
    <!-- Header -->
    <v-container class="pa-0 ma-0 d-flex justify-space-between align-center gap-2">
      <v-card-text class="pa-0 ma-0 text-body-2"> {{ $t("topCustomers") }} </v-card-text>

      <v-btn text small color="primary" class="ma-0 pa-0">
        {{ $t("viewAll") }}
        <v-icon small class="ma-0 pa-0">mdi-chevron-left</v-icon>
      </v-btn>
    </v-container>

    <!-- List -->
    <v-list v-if="hasData" dense class="pa-0 ma-0 scroll-y">
      <v-list-item
        v-for="(customer, index) in CustomerArray"
        :key="index"
        class="pa-0 ma-0"
      >
        <!-- Avatar -->
        <v-list-item-avatar size="40">
          <v-img v-if="customer.avatar" :src="customer.avatar" contain />
          <v-avatar v-else color="grey lighten-3">
            <v-icon color="grey"> mdi-account </v-icon>
          </v-avatar>
        </v-list-item-avatar>

        <!-- Info -->
        <v-list-item-content>
          <v-list-item-title class="pa-0 ma-0 text-body-1">
            {{ customer.customer_name }}
          </v-list-item-title>

          <v-list-item-subtitle class="pa-0 ma-0 py-1 text-body-2 grey--text">
            {{ customer.invoices }} {{ $t("order") }}
          </v-list-item-subtitle>
        </v-list-item-content>

        <!-- Amount -->
        <v-list-item-action>
          <v-container class="pa-0 ma-0 text-left">
            <v-card-text class="pa-0 ma-0 text-body-1">
              {{ formatPrice(customer.amount) }}
            </v-card-text>
            <v-card-text class="pa-0 ma-0 py-1 text-body-2 grey--text">{{
              $store.state.currency.name
            }}</v-card-text>
          </v-container>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-container
      v-else
      class="pa-0 ma-0 d-flex flex-column align-center justify-center"
      style="height: 337px"
    >
      <img
        :src="require('@/assets/dashboard/no-data(3).png')"
        max-width="100"
        height="100"
        contain
        class="mb-3"
      />
      <v-card-text class="text-body-2 grey--text text-center">
        {{ $t("nothing-for-render") }}
      </v-card-text>
    </v-container>
  </v-card>
</template>
<script>
export default {
  name: "TopCustomers",

  data() {
    return {
      CustomerArray: [],
      loading: false,
    };
  },
  computed: {
    hasData() {
      return this.CustomerArray.length > 0;
    },
  },
  mounted() {
    this.getTopCustomerData();
  },
  methods: {
    formatPrice(value) {
      if (value === null || value === undefined) return "-";
      return this.$numberFormat(value);
    },
    getTopCustomerData() {
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/charts/top-customers", {
          params: {
            dateType: "year",
          },
        })
        .then((response) => {
          let res = response.data.data.topCustomers.sell;
          app.CustomerArray = res.slice(-10);
        })
        .catch((err) => {
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.scroll-y {
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  -webkit-scrollbar: none;
}
</style>
